<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8" xl="6">
        <v-row align="stretch">
          <v-col v-for="(sponsor, idx) in event.sponsors" :key="idx" cols="12" sm="6" md="4"
                 xl="3">
            <sponsor :sponsor="sponsor" :show-name="event.sponsors_show_name"></sponsor>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import Sponsor from '@/components/Sponsor';


export default {
  name: 'Sponsors',
  components: {
    Sponsor,
  },
  mounted ()
  {
    this.setSponsorsLoading(false)
  },
  computed: {
    ...mapState( ['event'] ),
  },
  methods: {
    ...mapMutations( ['setSponsorsLoading'] ),
  },
};
</script>

<style scoped>

</style>